import { Fldr } from './datapoint/fldr';
import { DataObject } from './domain/dataobject';
import { DBFun } from './objects/dbfun';
import { LayerObject } from './layerobject';
import { RepConn } from './datapoint/repconn';
import { DBSeq } from './objects/dbseq';
import { SchTask } from './schtask';
import { SchTaskCalendar } from './schtaskcalendar';
import { Param } from './domain/param';
import { SchTaskEmail } from './schtaskemail';
import { SchTaskFile } from './schtaskfile';
import { CommonEnums } from '../common.enums';
import { Design } from './domain/design';
import { Stream } from './domain/stream';
import { RepFolder } from './objects/repfolder';
import { UDF } from './domain/udf';
import { FldrObjectUtil } from '../utils/fldrobject.util';
import { ParamsUtil } from './utils/params.util';

export class FldrObject {
    fldr: Fldr;
    repositoryName: string;

    connections: Array<RepConn>
    dataObjects: Array<DataObject>;
    dBFuns: Array<DBFun>;
    udfs: Array<UDF>;
    nativeSequences: Array<DBSeq>;

    layerObjects: Array<LayerObject>;

    layerObject: LayerObject;
    scheduleGroups: Array<SchTask>;
    schTasks: Array<SchTask>;
    schTaskCalendars: Array<SchTaskCalendar>;
    schTaskEmails: Array<SchTaskEmail>;
    schTaskFiles: Array<SchTaskFile>;
    // params: Array<Param>;
    // paramsCopy: Array<Param>;
    deleteParams: Array<Param>;
    repFolders: Array<RepFolder>;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.fldr = new Fldr();
        this.repositoryName = CommonEnums.defaults.STRING_EMPTY;
        this.dataObjects = new Array<DataObject>();
        this.dBFuns = new Array<DBFun>();
        this.udfs = new Array<UDF>();
        this.layerObjects = new Array<LayerObject>();
        this.connections = new Array<RepConn>();
        this.nativeSequences = new Array<DBSeq>();
        this.error_Cd = CommonEnums.defaults.ERROR_CD;
        this.error_Msg = CommonEnums.defaults.ERROR_MSG;

        this.scheduleGroups = new Array<SchTask>();
        this.schTasks = new Array<SchTask>();
        this.schTaskCalendars = new Array<SchTaskCalendar>();
        this.schTaskEmails = new Array<SchTaskEmail>();
        this.schTaskFiles = new Array<SchTaskFile>();
        // this.params = new Array<Param>();
        // this.paramsCopy = new Array<Param>();
        this.deleteParams = new Array<Param>();
        this.repFolders = new Array<RepFolder>();
    }

    clear(): void {
        this.connections.splice(0, this.connections.length);
        this.dataObjects.splice(0, this.dataObjects.length);
        this.nativeSequences.splice(0, this.nativeSequences.length);
        this.udfs.splice(0, this.udfs.length);
        this.dBFuns.splice(0, this.dBFuns.length);
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            layerObject.maps.splice(0, layerObject.maps.length);
            layerObject.flows.splice(0, layerObject.flows.length);
        }
        // this.params.splice(0, this.params.length);
        // this.paramsCopy.splice(0, this.paramsCopy.length);
        this.deleteParams.splice(0, this.deleteParams.length);
        this.repFolders.splice(0, this.repFolders.length);
    }

    setChange_Ind(): void {
        for (let i: number = 0; i < this.connections.length; i++) {
            if (this.connections[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                return;
            }
        }

        for (let i: number = 0; i < this.dataObjects.length; i++) {
            if (this.dataObjects[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                return;
            }
        }

        for (let i: number = 0; i < this.nativeSequences.length; i++) {
            if (this.nativeSequences[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                return;
            }
        }
        //udf

        for (let i: number = 0; i < this.udfs.length; i++) {
            if (this.udfs[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                return;
            }
        }
        //dbfun

        for (let i: number = 0; i < this.dBFuns.length; i++) {
            if (this.dBFuns[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                return;
            }
        }

        for (let i: number = 0; i < this.repFolders.length; i++) {
            if (this.repFolders[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                return;
            }
        }

        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.maps.length; j++) {
                if (layerObject.maps[j].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                    this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                    return;
                }
            }

            for (let j: number = 0; j < layerObject.flows.length; j++) {
                if (layerObject.flows[j].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                    this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
                    return;
                }
            }
        }

        if (this.deleteParams.length > 0) {
            this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
            return;
        }

        // let unsavedParams = ParamsUtil.getInstance().getChangedParams(this.params, this.paramsCopy);
        // if (unsavedParams.length > 0) {
        //     this.fldr.change_Ind = CommonEnums.change_Ind.CHANGED;
        //     return;
        // }

        this.fldr.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    }

    getUnSavedObjects(): Array<number> {
        let unsavedObjects: Array<any> = new Array<any>();
        for (let i: number = 0; i < this.connections.length; i++) {
            if (this.connections[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjects.push(this.connections[i]);
            }
        }

        for (let i: number = 0; i < this.dataObjects.length; i++) {
            if (this.dataObjects[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjects.push(this.dataObjects[i]);
            }
        }

        for (let i: number = 0; i < this.nativeSequences.length; i++) {
            if (this.nativeSequences[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjects.push(this.nativeSequences[i]);
            }
        }

        for (let i: number = 0; i < this.udfs.length; i++) {
            if (this.udfs[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjects.push(this.udfs[i]);
            }
        }

        for (let i: number = 0; i < this.dBFuns.length; i++) {
            if (this.dBFuns[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjects.push(this.dBFuns[i]);
            }
        }

        for (let i: number = 0; i < this.repFolders.length; i++) {
            if (this.repFolders[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjects.push(this.repFolders[i]);
            }
        }

        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.maps.length; j++) {
                let design: Design = layerObject.maps[j];
                if (design.change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                    unsavedObjects.push(design);
                }
            }
        }

        // streams has to save after all designs save completed..
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.flows.length; j++) {
                let stream: Stream = layerObject.flows[j];
                if (stream.change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                    unsavedObjects.push(stream);
                }
            }
        }

        // let unsavedParams: Array<Param> = this.getUnsavedProjectParams();
        // if (unsavedParams.length > 0) {
        //     unsavedObjects.push(unsavedParams[0]);
        // }

        return unsavedObjects;
    }

    getUnsavedProjectParams(params: Array<Param> = new Array<Param>(), paramsCopy: Array<Param> = new Array<Param>()): Array<Param> {
        let unsavedParams: Array<Param> = ParamsUtil.getInstance().getChangedParams(params, paramsCopy);
        if (this.deleteParams.length > 0) {
            for (let i: number = 0; i < this.deleteParams.length; i++) {
                this.deleteParams[i].change_Ind = 'D';
                unsavedParams.push(this.deleteParams[i]);
            }
        }
        return unsavedParams;
    }

    getDxMp_Ids(): Array<number> {
        let dxMp_Ids: Array<number> = new Array<number>();
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.maps.length; j++) {
                dxMp_Ids.push(layerObject.maps[j].dxMp.dxMp_Id);
            }
        }

        return dxMp_Ids;
    }

    getUnsavedObj_Ids(): Array<number> {
        let unsavedObj_Ids: Array<number> = new Array<number>();
        for (let i: number = 0; i < this.connections.length; i++) {
            if (this.connections[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObj_Ids.push(this.connections[i].conn.conn_Id);
            }
        }

        for (let i: number = 0; i < this.dataObjects.length; i++) {
            if (this.dataObjects[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObj_Ids.push(this.dataObjects[i].dObj.dObj_Id);
            }
        }

        //seq
        for (let i: number = 0; i < this.nativeSequences.length; i++) {
            if (this.nativeSequences[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObj_Ids.push(this.nativeSequences[i].native_Db_Seq.native_Db_Seq_Id);
            }
        }

        //udf
        for (let i: number = 0; i < this.udfs.length; i++) {
            if (this.udfs[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObj_Ids.push(this.udfs[i].usr_Def_Fun.udf_Id);
            }
        }

        //dbfun
        for (let i: number = 0; i < this.dBFuns.length; i++) {
            if (this.dBFuns[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObj_Ids.push(this.dBFuns[i].dxFun.dxFun_Id);
            }
        }

        //dbfun
        for (let i: number = 0; i < this.repFolders.length; i++) {
            if (this.repFolders[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObj_Ids.push(this.repFolders[i].fldr.fldr_Id);
            }
        }

        //dataflow/jobflow
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.flows.length; j++) {
                if (layerObject.flows[j].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                    unsavedObj_Ids.push(layerObject.flows[j].dxFlow.dxFlow_Id);
                }
            }
        }

        return unsavedObj_Ids;
    }

    getUnsavedDxMp_Ids(): Array<number> {
        let unsavedObj_Ids: Array<number> = new Array<number>();
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.maps.length; j++) {
                if (layerObject.maps[j].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                    unsavedObj_Ids.push(layerObject.maps[j].dxMp.dxMp_Id);
                }
            }
        }

        return unsavedObj_Ids;
    }

    getObjectById(obj_Id: number) {

        for (let i: number = 0; i < this.connections.length; i++) {
            if (this.connections[i].conn.conn_Id == obj_Id) {
                return this.connections[i];
            }
        }

        for (let i: number = 0; i < this.dataObjects.length; i++) {
            if (this.dataObjects[i].dObj.dObj_Id == obj_Id) {
                return this.dataObjects[i];
            }
        }

        for (let i: number = 0; i < this.dBFuns.length; i++) {
            if (this.dBFuns[i].dxFun.dxFun_Id == obj_Id) {
                return this.dBFuns[i];
            }
        }

        for (let i: number = 0; i < this.udfs.length; i++) {
            if (this.udfs[i].usr_Def_Fun.udf_Id == obj_Id) {
                return this.udfs[i];
            }
        }

        for (let i: number = 0; i < this.nativeSequences.length; i++) {
            if (this.nativeSequences[i].native_Db_Seq.native_Db_Seq_Id == obj_Id) {
                return this.nativeSequences[i];
            }
        }

        for (let i: number = 0; i < this.repFolders.length; i++) {
            if (this.repFolders[i].fldr.fldr_Id == obj_Id) {
                return this.repFolders[i];
            }
        }

        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];


            for (let j: number = 0; j < layerObject.maps.length; j++) {
                let design: Design = layerObject.maps[j];
                if (design.dxMp.dxMp_Id == obj_Id) {
                    return design;

                }
            }

            for (let j: number = 0; j < layerObject.flows.length; j++) {
                let stream: Stream = layerObject.flows[j];
                if (stream.dxFlow.dxFlow_Id == obj_Id) {
                    return stream;
                }
            }
        }
    }

    getLayerObject(layer_Id: number): LayerObject {
        for (let i: number = 0; i < this.layerObjects.length; i++) {

            let layerObject: LayerObject = this.layerObjects[i];

            if (layerObject.layer.layer_Id == layer_Id) {
                return layerObject;
            }

        }
    }

    splice(object: any, obj_Id: number = -1, obj_Cd: string = "", reusableFlag: string = CommonEnums.reusableFlag.NO,
        streamingFlg: string = CommonEnums.streamingFlg.NO): Array<any> {
        if (obj_Cd == "") {
            obj_Cd = FldrObjectUtil.getInstance().getObj_Cd(object);
        }
        if (obj_Cd == "") return null;

        if (obj_Id == -1) {
            obj_Id = FldrObjectUtil.getInstance().getObj_Id(object);
        }
        if (obj_Id == -1) return null;

        switch (obj_Cd) {
            case CommonEnums.codes.REPCONN:
                for (let i: number = 0; i < this.connections.length; i++) {
                    if (this.connections[i].conn.conn_Id == obj_Id) {
                        return this.connections.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.DATAOBJECT:
                for (let i: number = 0; i < this.dataObjects.length; i++) {
                    if (this.dataObjects[i].dObj.dObj_Id == obj_Id) {
                        return this.dataObjects.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.DESIGN:
                for (let i: number = 0; i < this.layerObjects.length; i++) {
                    let layerObject: LayerObject = this.layerObjects[i];
                    if (layerObject.layer.layer_Id != object.dxMp.layer_Id) continue;

                    for (let j: number = 0; j < layerObject.maps.length; j++) {
                        if (layerObject.maps[j].dxMp.dxMp_Id == obj_Id) {
                            return layerObject.maps.splice(j, 1);
                        }
                    }
                }
                break;
            case CommonEnums.codes.STREAM:
                for (let i: number = 0; i < this.layerObjects.length; i++) {
                    let layerObject: LayerObject = this.layerObjects[i];
                    if (layerObject.layer.layer_Id != object.dxFlow.layer_Id) continue;

                    for (let j: number = 0; j < layerObject.flows.length; j++) {
                        if (layerObject.flows[j].dxFlow.dxFlow_Id == obj_Id) {
                            return layerObject.flows.splice(j, 1);
                        }
                    }
                }
                break;

            case CommonEnums.codes.DBFUN:
                for (let i: number = 0; i < this.dBFuns.length; i++) {
                    if (this.dBFuns[i].dxFun.dxFun_Id == obj_Id) {
                        return this.dBFuns.splice(i, 1);
                    }
                }
                break;

            case CommonEnums.codes.UDF:
                for (let i: number = 0; i < this.udfs.length; i++) {
                    if (this.udfs[i].usr_Def_Fun.udf_Id == obj_Id) {
                        return this.udfs.splice(i, 1);
                    }
                }
                break;

            case CommonEnums.codes.DBSEQ:
                for (let i: number = 0; i < this.nativeSequences.length; i++) {
                    if (this.nativeSequences[i].native_Db_Seq.native_Db_Seq_Id == obj_Id) {
                        return this.nativeSequences.splice(i, 1);
                    }
                }
                break;
        }

        return null;
    }

    updateObject(object: any): void {
        let obj_Cd = FldrObjectUtil.getInstance().getObj_Cd(object);

        switch (obj_Cd) {
            case CommonEnums.codes.REPCONN:
                this.updateRepConn(object);
                return;
            case CommonEnums.codes.DATAOBJECT:
                this.updateDataObject(object);
                return;
            case CommonEnums.codes.DESIGN:
                this.updateDesign(object);
                return;
            case CommonEnums.codes.STREAM:
                this.updateStream(object);
                return;
            case CommonEnums.codes.DBFUN:
                this.updateDBFun(object);
                return;
            case CommonEnums.codes.UDF:
                this.updateUDF(object);
                return;
            case CommonEnums.codes.DBSEQ:
                this.updateDBSeq(object);
                return;
            default: return null;
        }
    }


    /**
     * @repconn
     */
    addRepConn(repConn: RepConn): RepConn {
        let repConnExist: RepConn = this.getRepConn(repConn.conn.conn_Id);

        if (repConnExist) {
            if (repConnExist.change_Ind == CommonEnums.change_Ind.NO_CHANGE) {
                repConnExist.copyFrom(repConn);
            }

            return repConnExist;
        }

        this.connections.push(repConn);
        return repConn;
    }

    updateRepConn(repConnCopy: RepConn): void {
        let repConn: RepConn = this.getObjectById(repConnCopy.conn.conn_Id) as RepConn;
        repConn.copyFrom(repConnCopy);
    }

    compareRepConn(repConn: RepConn, repConnCopy: RepConn): void {
        let diffString = repConn.compare(repConnCopy);
        if (diffString != '') {
            if (repConn.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                repConn.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getRepConn(conn_Id: number) {
        for (let i: number = 0; i < this.connections.length; i++) {
            if (this.connections[i].conn.conn_Id == conn_Id) {
                return this.connections[i];
            }
        }

    }

    addDataObject(dataObject: DataObject): DataObject {
        let dataObjectExist: DataObject = this.getDataObject(dataObject.dObj.dObj_Id);
        if (dataObjectExist) {
            if (dataObjectExist.change_Ind == CommonEnums.change_Ind.NO_CHANGE) {
                dataObjectExist.copyFrom(dataObject);
            }

            return dataObjectExist;
        }

        this.dataObjects.push(dataObject);
        return dataObject
    }

    updateDataObject(dataObjectCopy: DataObject): void {
        let dataObject: DataObject = this.getObjectById(dataObjectCopy.dObj.dObj_Id) as DataObject;
        dataObject.copyFrom(dataObjectCopy);
    }

    compareDataObject(dataObject: DataObject, dataObjectCopy: DataObject): void {
        let diffString = dataObject.compare(dataObjectCopy);
        if (diffString != '') {
            if (dataObject.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                dataObject.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getDataObject(dObj_Id: number): DataObject {
        for (let i: number = 0; i < this.dataObjects.length; i++) {
            if (this.dataObjects[i].dObj.dObj_Id == dObj_Id) {
                return this.dataObjects[i];
            }
        }
        return null;
    }

    addDesign(design: Design): Design {
        let layerObject: LayerObject = this.getLayerObject(design.dxMp.layer_Id);

        if (layerObject == null) {
            layerObject = new LayerObject();
            layerObject.layer.layer_Id = design.dxMp.layer_Id;
            this.layerObjects.push(layerObject)
        }

        let designExist: Design = this.getDesign(design.dxMp.dxMp_Id, design.dxMp.layer_Id);
        if (designExist) {
            if (designExist.change_Ind == CommonEnums.change_Ind.NO_CHANGE) {
                designExist.copyFrom(design);
            }

            return designExist;
        }

        layerObject.maps.push(design);
        return design;
    }


    updateDesign(designCopy: Design): void {
        let design: Design = this.getObjectById(designCopy.dxMp.dxMp_Id) as Design;
        design.copyFrom(designCopy);
    }

    compareDesign(design: Design, designCopy: Design): void {
        let diffString = design.compare(designCopy);
        if (diffString != '') {
            if (design.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                design.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getDesign(dxMp_Id: number, layer_Id: number = -1): Design {
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];
            if (layer_Id != -1 &&
                layerObject.layer.layer_Id != layer_Id) continue;

            for (let j: number = 0; j < layerObject.maps.length; j++) {
                let design: Design = layerObject.maps[j];
                if (design.dxMp.dxMp_Id == dxMp_Id) {
                    return design;
                }
            }
        }
        return null;
    }

    /**
     * @stream
     */
    addStream(stream: Stream): Stream {
        let layerObject: LayerObject = this.getLayerObject(stream.dxFlow.layer_Id);

        if (layerObject == null) {
            layerObject = new LayerObject();
            layerObject.layer.layer_Id = stream.dxFlow.layer_Id;
            this.layerObjects.push(layerObject)
        }

        let streamExit: Stream = this.getStream(stream.dxFlow.dxFlow_Id, stream.dxFlow.layer_Id);
        if (streamExit) {
            streamExit.copyFrom(stream);
            return streamExit;
        }
        layerObject.flows.push(stream);
        return stream;
    }

    updateStream(streamCopy: Stream): void {
        let stream: Stream = this.getObjectById(streamCopy.dxFlow.dxFlow_Id) as Stream;
        stream.copyFrom(streamCopy);
    }

    compareStream(stream: Stream, streamCopy: Stream): void {
        let diffString = stream.compare(streamCopy);
        if (diffString != '') {
            if (stream.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                stream.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getStream(dxFlow_Id: number, layer_Id: number = -1): Stream {
        for (let i: number = 0; i < this.layerObjects.length; i++) {
            let layerObject: LayerObject = this.layerObjects[i];

            for (let j: number = 0; j < layerObject.flows.length; j++) {
                let stream: Stream = layerObject.flows[j];
                if (stream.dxFlow.dxFlow_Id == dxFlow_Id) {
                    return stream;
                }
            }
        }

        return null;
    }

    /**
     * @dbFun
     */
    addDbFun(dbFun: DBFun): DBFun {
        let dbFunExist: DBFun = this.getDbFun(dbFun.dxFun.dxFun_Id);
        if (dbFunExist) {
            dbFunExist.copyFrom(dbFun);
            return dbFunExist;
        }

        this.dBFuns.push(dbFun);
        return dbFun;
    }

    updateDBFun(dbFunCopy: DBFun): void {
        let dbFun: DBFun = this.getObjectById(dbFunCopy.dxFun.dxFun_Id) as DBFun;
        dbFun.copyFrom(dbFunCopy);
    }

    compareDBFun(dbfun: DBFun, dbFunCopy: DBFun): void {
        let diffString = dbfun.compare(dbFunCopy);
        if (diffString != '') {
            if (dbfun.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                dbfun.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getDbFun(dbFun_Id: number): DBFun {
        for (let i: number = 0; i < this.dBFuns.length; i++) {
            if (this.dBFuns[i].dxFun.dxFun_Id == dbFun_Id) {
                return this.dBFuns[i];
            }
        }
        return null;
    }

    /**
     * @addUDF
     */
    addUDF(uDF: UDF): UDF {
        let uDFExist: UDF = this.getUdf(uDF.usr_Def_Fun.udf_Id);
        if (uDFExist) {
            if (uDFExist.change_Ind == CommonEnums.change_Ind.NO_CHANGE) {
                uDFExist.copyFrom(uDF);
            }

            return uDFExist;
        }

        this.udfs.push(uDF);
        return uDF;
    }

    updateUDF(udfCopy: UDF): void {
        let udf: UDF = this.getObjectById(udfCopy.usr_Def_Fun.udf_Id) as UDF;
        udf.copyFrom(udfCopy);
    }

    compareUDF(uDF: UDF, udfCopy: UDF): void {
        let diffString = uDF.compare(udfCopy);
        if (diffString != '') {
            if (uDF.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                uDF.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getUdf(udf_Id: number): UDF {
        for (let i: number = 0; i < this.udfs.length; i++) {
            if (this.udfs[i].usr_Def_Fun.udf_Id == udf_Id) {
                return this.udfs[i];
            }
        }
        return null;
    }

    /**
     * @dbSeq
     */
    addDBSeq(dBSeq: DBSeq): DBSeq {
        let dBSeqExist: DBSeq = this.getDbSeq(dBSeq.native_Db_Seq.native_Db_Seq_Id);
        if (dBSeqExist) {
            dBSeqExist.copyFrom(dBSeq);
            return dBSeqExist;
        }

        this.nativeSequences.push(dBSeq);
        return dBSeq;
    }

    updateDBSeq(dbseqCopy: DBSeq): void {
        let dbseq: DBSeq = this.getObjectById(dbseqCopy.native_Db_Seq.native_Db_Seq_Id) as DBSeq;
        dbseq.copyFrom(dbseqCopy);
    }

    compareDBSeq(dbseq: DBSeq, dbseqCopy: DBSeq): void {
        let diffString = dbseq.compare(dbseqCopy);
        if (diffString != '') {
            if (dbseq.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                dbseq.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getDbSeq(dbseq_Id: number): DBSeq {
        for (let i: number = 0; i < this.nativeSequences.length; i++) {
            if (this.nativeSequences[i].native_Db_Seq.native_Db_Seq_Id == dbseq_Id) {
                return this.nativeSequences[i];
            }
        }

        return null;
    }

    /**
     * @repFolder
     */
    addRepFolder(repFolder: RepFolder): RepFolder {
        let repFolderExists: RepFolder = this.getRepFolder(repFolder.fldr.fldr_Id);
        if (repFolderExists) {
            if (repFolderExists.change_Ind == CommonEnums.change_Ind.NO_CHANGE) {
                repFolderExists.copyFrom(repFolder);
            }

            return repFolderExists;
        }

        this.repFolders.push(repFolder);
        return repFolder;
    }

    updateRepFolder(repFolderCopy: RepFolder): void {
        let repFolder: RepFolder = this.getObjectById(repFolderCopy.fldr.fldr_Id) as RepFolder;
        repFolder.copyFrom(repFolderCopy);
    }

    compareRepFolder(repFolder: RepFolder, repFolderCopy: RepFolder): void {
        let diffString = repFolder.compare(repFolderCopy);
        if (diffString != '') {
            if (repFolder.change_Ind == CommonEnums.change_Ind.NO_CHANGE)
                repFolder.change_Ind = CommonEnums.change_Ind.CHANGED;
        }
    }

    getRepFolder(fldr_Id: number): RepFolder {
        for (let i: number = 0; i < this.repFolders.length; i++) {
            if (this.repFolders[i].fldr.fldr_Id == fldr_Id) {
                return this.repFolders[i];
            }
        }

        return null;
    }
}